import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiptComponent } from './receipt.component';
import { ReceiptIndexComponent } from './receipt-index/receipt-index.component';
import {CardModule} from '../../resources/components/card/card.module';
import {ReceiptRoutesModule} from './receipt-routes/receipt-routes.module';
import {TableReceiptModule} from '../../resources/tables/table-receipt/table-receipt.module';



@NgModule({
  declarations: [ReceiptComponent, ReceiptIndexComponent],
  imports: [
    CommonModule,
    CardModule,
    ReceiptRoutesModule,
    TableReceiptModule
  ]
})
export class ReceiptModule { }
